// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__Iky0F","buttons":"SendReceipts_buttons__1apsv","email":"SendReceipts_email__10zlX","bookApptTitle":"SendReceipts_bookApptTitle__s5cFl"};